module.exports = __webpack_public_path__ + "3b47d55b8433e42895d30f4668c2643d.png";